import type { NavbarConfig } from '@practium/ui';
import { useAuth } from '@practium/features/auth';
import { useGetMe } from '@practium/features/api';
import userAvatar from '/avatars/user-avatar.png';
import { useNavigate } from 'react-router-dom';

export const useAdminNavbarConfig = (): NavbarConfig => {
	const { user } = useAuth();
	const { data: me } = useGetMe();
	const navigate = useNavigate();

	return {
		title: 'Dashboard',
		user: {
			name: user?.name || 'Usuário',
			avatar: me?.avatar?.url || userAvatar,
			role: 'Administrador',
		},
		onSearch: (_query: string) => { },
		onNotificationClick: () => { },
		onUserMenuClick: () => {
			navigate('/perfil')
		},
		notificationCount: 3,
	};
};
